import { variation } from 'ember-launch-darkly';

export default (): boolean =>
  variation('hcp-ui-cookie-auth') ||
  localStorage.getItem('hcp-ui-cookie-auth') === 'true';
